import addBasicPlan from './addBasicPlan';
import processAvailablePlans from './processAvailablePlans';
import AppState from '../AppState';
/**
 * Get other plans available for the address when the selected is not available.
 *
 * @param {AvailableSelections[]} availablePlans - The list of available plans
 * @returns {void}
 */
const getOtherServicesAvailable = (availablePlans) => {
    const planId = AppState.get('planId');
    const sfpModel = AppState.get('serviceFunnelPackage');
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal, context } = drupalJsObjects;
    const serviceAvailable = context.querySelector('#service-available');
    const serviceSelected = context.querySelector('#service-selected');
    const messageWrapper = context.querySelector('#message-wrapper');
    messageWrapper.style.display = 'block';
    messageWrapper.classList.add('product-unavailable--oops');
    serviceAvailable.style.display = 'block';
    serviceAvailable.querySelector('.product-unavailable--text').style.display = 'block';
    serviceAvailable.classList.add('product-unavailable', 'address-tile', 'p-lg-4');
    serviceSelected.classList.remove('selected');
    serviceSelected.classList.add('disabled');
    context.querySelector('#plan-selection-title').style.display = 'none';
    context.querySelector('#product-unavailable-icon').style.display = 'block';
    context.querySelector(`#offer-badges-${planId}`).innerHTML = `
    <li class="badge">${Drupal.t('Not available at the address')}</li>
  `;
    context.querySelector('#select-different').style.display = 'none';
    // Assemble plans
    const plan = sfpModel.bundles.find((bundle) => bundle.PlanGroupID === 162);
    const basicPlan = addBasicPlan(plan);
    const allPlans = availablePlans.concat(basicPlan);
    processAvailablePlans(plan, allPlans);
};
export default getOtherServicesAvailable;
